import type { AvailableLanguagesType } from '@carrefour-gcs/shared';

import { getDocumentationURL } from '#domain/core/documentation/documentation.query';

export const handleDocumentationAuth = async (lang: AvailableLanguagesType) => {
  const url = await getDocumentationURL(lang, false);

  window.open(url, '_blank');
};

export const handleProductTourDocumentationAuth = async (lang: AvailableLanguagesType) => {
  const url = await getDocumentationURL(lang, true);

  window.open(url, '_blank');
};
